import React from "react";
import AgreementsFooter from "./agreementsMolcule/agreementsFooter";
import AgreementsHeader from "./agreementsMolcule/agreementsHeader";
import UserBody from "./agreementsMolcule/userBody";

class User extends React.Component {
  render() {
    return (
      <div>
        <AgreementsHeader></AgreementsHeader>
        <UserBody></UserBody>
        <AgreementsFooter></AgreementsFooter>
      </div>
    );
  }
}

export default User;
